module.exports = __webpack_public_path__ + "static/media/cuttingBack.e7038fd4.mp3";